import { render, staticRenderFns } from "./new-canvas.vue?vue&type=template&id=47325ac9&scoped=true&"
import script from "./new-canvas.vue?vue&type=script&lang=js&"
export * from "./new-canvas.vue?vue&type=script&lang=js&"
import style0 from "./new-canvas.vue?vue&type=style&index=0&id=47325ac9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47325ac9",
  null
  
)

export default component.exports